<template>
  <div class="headerTop">
    <header class="header wrap">
      <div class="topBox flex_between main">
        <div class="flex_center topBox_left">
          <img id="logo" @click="goHome" src="https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logo.jpg" />
          <div class="navigation_ul flex_center">
            <div style="flex:1" class="flex_start">
              <router-link class="navigation_li flex_center" :class="{ selected: headIndex == 1 }" to="/" colorstyle="blue">
                <img src="@/assets/img/home/baiicon/icon_sy.png" alt="" class="tab_icon" v-if="headIndex == 1" />
                <img src="@/assets/img/home/icon_sy.png" alt="" class="tab_icon" v-else />
                <p>首页</p>
              </router-link>
              <router-link class="navigation_li flex_center" v-if="user.id == undefined || user.check_status == undefined || user.check_status != 1" :class="{ selected: headIndex == 2 }" to="" @click.native="note" colorstyle="blue">
                <img src="@/assets/img/home/baiicon/icon_wz.png" alt="" class="tab_icon" v-if="headIndex == 2" />
                <img src="@/assets/img/home/icon_wz.png" alt="" class="tab_icon" v-else />
                <p>文章</p>
              </router-link>
              <router-link class="navigation_li flex_center" v-else :class="{ selected: headIndex == 2 }" :to="{name:'column', query: {id:0}}" colorstyle="blue">
                <img src="@/assets/img/home/baiicon/icon_wz.png" alt="" class="tab_icon" v-if="headIndex == 2" />
                <img src="@/assets/img/home/icon_wz.png" alt="" class="tab_icon" v-else />
                <p>文章</p>
              </router-link>
              <router-link class="navigation_li flex_center sp_re" :class="{ selected: headIndex == 3 }" :to="{name:'vedioIndex', query: {id:1}}" colorstyle="blue">
                <img src="@/assets/img/home/baiicon/icon_sp.png" alt="" class="tab_icon" v-if="headIndex == 3" />
                <img src="@/assets/img/home/icon_sp.png" alt="" class="tab_icon" v-else />
                <p>视频</p>
                <!-- 下拉 -->
                <div class="drop_box">
                  <!-- <div class="item" @click.self="test">大咖金句</div> -->
                  <router-link :to="{name:'vedioList', query: {cateid:item.id}}" v-for="(item) in videilist" :key="item.id">
                    <div class="item">
                      {{ item.title }}
                    </div>
                  </router-link>
                  <router-link :to="{name:'vedioList', query: {cateid:0}}">
                    <div class="item">
                      更多
                    </div>
                  </router-link>
                  <!-- <div class="item" @click="tabopen(index)" v-for="(item,index) in videilist" :key="item.id">
                  {{ item.title }}
                </div> -->
                </div>
              </router-link>
              <router-link class="navigation_li flex_center" :class="{ selected: headIndex == 4 }" to="/index" colorstyle="blue">
                <img src="@/assets/img/home/baiicon/icon_zb.png" alt="" class="tab_icon" v-if="headIndex == 4" />
                <img src="@/assets/img/home/icon_zb.png" alt="" class="tab_icon" v-else />
                <p>直播</p>
              </router-link>
              <!-- <router-link class="navigation_li flex_center" :class="{ selected: headIndex == 5 }" to="/product" colorstyle="blue">
                <img src="@/assets/img/home/baiicon/icon_sd.png" alt="" class="tab_icon" v-if="headIndex == 5" />
                <img src="@/assets/img/home/icon_sd.png" alt="" class="tab_icon" v-else />
                <p>医疗器械信息 </p>
              </router-link> -->
              <router-link target="_blank" v-if="user.id && user.check_status == 1 && user.is_show_file == 1" class="navigation_li flex_center" :class="{ selected: headIndex == 6 }" to="/contentFile" colorstyle="blue">
                <img src="@/assets/img/home/baiicon/file.png" alt="" class="tab_icon2" v-if="headIndex == 6" />
                <img src="@/assets/img/home/file.png" alt="" class="tab_icon2" v-else />
                <p>内容文件</p>
              </router-link>
            </div>

            <div class="sousuo_div flex_between">
              <el-dropdown trigger="click" :hide-on-click="false" placement="bottom-start" @command="handleCommand">
                <input type="text" placeholder="请输入查找内容" name="" @focus="searshow=true" @blur="searshow=false" @keyup.enter="search" v-model="search_text" id="" />
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="item" v-for="(item,index) in seararr" :key="index" icon="el-icon-time">{{item}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <i @click="search"><img src="@/assets/img/home/icon_cz.png" alt="" class="icon_search" /></i>
            </div>+
          </div>
        </div>
        <div class="imgmessage" :class="{ unread: user.read == 0 }" v-if="user">
          <img src="@/assets/img/message.png" alt="" @click.stop="message">
        </div>
        <div style="position: relative;" class="flex_center login_button" v-if="USER().id != undefined" @click.stop="personal">
          <i><img :src="user.image" alt="" /></i>
          <div style="text-align: center;padding:3px">
            <span>{{user.username }}</span>
          </div>

        </div>
        <div class="flex_center login_button" v-else>
          <i><img src="@/assets/img/morenimg.png" alt="" /></i>
          <p class="msg">
            <span @click="registered(1)">登录</span>
            <span @click="registered(3)">注册</span>
          </p>
        </div>
      </div>
    </header>
    <!-- 提示权限弹窗 -->
    <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>
    <!-- 提示注册弹窗 -->
    <LoginPrompt1 @promptFun1="promptFun1" ref="prompt1"></LoginPrompt1>
    <!-- 登录 -->
    <Login ref="login" @getUser="getUser" @privacyFun="privacyFun"></Login>
    <!-- 用户 -->
    <PC_agreement v-if="is_agreement" @privacyFun="privacyFun"></PC_agreement>
    <!-- 隐私 -->
    <PC_privacy v-if="is_privacy" @privacyFun="privacyFun"></PC_privacy>
  </div>
</template>

<script>
import Login from "@/components/assembly/Login.vue"; //登录模块
import PC_privacy from "@/components/tool/PC_privacy.vue"; //用户协议模块
import PC_agreement from "@/components/tool/PC_agreement.vue"; //隐私协议模块
import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //提示注册模块
import LoginPrompt1 from "@/components/assembly/LoginPrompt1.vue"; //提示注册模块
export default {
  name: "headerTop",
  data() {
    return {
      is_login: false, //是否显示登录
      user: {}, //用户信息

      is_agreement: false, //用户协议
      is_privacy: false, //显示隐私

      search_text: "", //搜索内容
      videilist: [],
      seararr: [],
      searshow: false
    };
  },
  components: {
    Login,
    PC_privacy,
    PC_agreement,
    LoginPrompt,
    LoginPrompt1
  },
  props: {
    headIndex: {
      type: Number,
    },
    setext: {
      type: String,
    },
  },

  methods: {
    note(){
      if (this.USER().id == undefined) {
          this.prompt1Show();
          return false;
        }else{
          console.log(this.USER(),'cjheck')
          if(this.USER().check_status != 1){
            this.prompt2Show();
            return false;
          }
        }
    },
    handleCommand(command) {
      this.search_text = command
    },
    getsearlist() {
      if (sessionStorage.getItem('seartext')) {
        let arr = sessionStorage.getItem('seartext').split(',')
        if (arr.length > 10) {
          this.seararr = arr.reverse().slice(0, 10)
        } else {
          this.seararr = arr.reverse()
        }
      } else {
        this.seararr = []
      }
    },
    getsearch() {
      if (sessionStorage.getItem("text")) {
        this.search_text = sessionStorage.getItem("text");
      } else {
        this.search_text = ''
      }
    },
    test() {
      alert("123");
    },
    message() {
      //跳转消息页面
      this.$router.replace({ path: "/message" });
    },
    headerFun(text) {
      this.search_text = text;
    },
    bayFun(e) {
      //点击回车
      if (e.which == 13) {
        this.search();
      }
    },
    // 分类点击
    tabopen(index) {
      this.$router.push({ name: 'vedioList', query: { cateid: 'index' } })
    },
    search() {
      if (!this.search_text) {
        this.search_text = ''
        sessionStorage.setItem("text", this.search_text);

      } else {
      }
      // this.headerFun(this.search_text)
      this.$emit("searchFun", this.search_text);
      this.seachtextcang(this.search_text)
      if (this.$route.path === "/search_info") {
        sessionStorage.removeItem("search");

      } else {
        sessionStorage.setItem("search", this.search_text);
        sessionStorage.setItem("text", this.search_text);
        this.$router.push({
          path: "/search_info",
          query: { seartext: this.search_text },
        });

      }
    },
    seachtextcang(text) {
      if (sessionStorage.getItem('seartext')) {
        let arr1 = sessionStorage.getItem('seartext').split(',')
        arr1.push(text)
        sessionStorage.setItem('seartext', arr1.join())
      } else {
        let arr = []
        arr.push(text)
        sessionStorage.setItem('seartext', arr.join())
      }

    },
    promptFun1(){
      this.registered(1);
    },
    prompt1Show() {
      //打开提示弹窗回调
      this.$refs.prompt1.popupFun1();
    },
    prompt2Show() {
      //打开审核状态提示语弹窗回调
      this.$refs.prompt1.popupFun2();
    },
    promptFun() {
      //提示弹窗回调
      this.registered(1);
    },
    promptShow() {
      //打开提示弹窗回调
      this.$refs.prompt.popupFun();
    },
    privacyFun(index) {

      if (index == 1) {
        this.is_agreement = !this.is_agreement;
      }
      if (index == 2) {
        this.is_privacy = !this.is_privacy;
      }
    },
    getUser() {
      console.log(this.USER(),'1111111111111');
      if(this.USER().mobile){
        this.$post('refresh', {
          mobile:this.USER().mobile
        }).then(res => {
         this.user = res.data
          console.log(this.user,'getUser');
        })
      }
     
      //传递父组件
      if(this.headIndex == 4){
        this.$parent.setUser();
      } 
    },
    registered(index) {
      //1登录 3注册
      this.$refs.login.loginFun(index);
      this.is_login = true;
    },
    personal() {
      //个人中心
      this.$router.push("/personal");
    },
    goHome() {
      //跳转首页
      this.$router.push("/");
    },
    async getvedio() {
      // 获取视频跳转
      let res = await this.$get("video-conf");
      if (res.data.length > 9) {
        res.data = res.data.reverse().slice(0, 8)
      }
      this.videilist = res.data.reverse();
    },
  },
  activated() {
    if (this.$route.path !== "/search_info") {
      this.search_text = ''
    }
    this.getsearlist()
    this.getUser();
    this.getvedio();
  },
  mounted() {
    this.getUser();
    this.getvedio();
    this.getsearlist()
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
<style scoped>
.el-dropdown-menu {
  width: 248px !important;
}
header {
  /* position: absolute;
  top: 0;
  left: 0; */
  height: 112px;
  display: flex;
  min-width: 1280px;
  align-items: center;
  z-index: 997;
  background: #fff;
  box-shadow: 0 0 9px rgba(71, 71, 71, 0.11);
  /* padding: 0px 100px; */
  /* padding-left: 100px; */
}

#logo {
  height: 36px;
  width: 185px;
  margin-left: 66px;
}
.main {
  max-width: 1280px;
  /* min-width: 865px; */
  margin: 0 auto;
  width: 1280px;
}
.topBox_left {
  padding-right: 30px;
  flex: 1;
}
.hidden-xs {
  /*padding-top:60px;*/
}

.topBox {
  height: 110px;
}

.topBox img {
  /* width: 155px; */
  height: auto;
  cursor: pointer;
}

.topBox .goWebsite {
  display: inline-block;
  background-color: #f24d5b;
  height: 34px;
  width: 153px;
  text-align: center;
  line-height: 34px;
  font-size: 13px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  color: #fff;
}

.topBox .goWebsite:hover {
  -moz-box-shadow: 0px 0px 2px #40a9ff;
  /* 老的 Firefox */
  box-shadow: 0px 0px 2px #40a9ff;
  font-size: 15px;
}

.topBox .portrait_div .portrait {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f4f7fd;
  overflow: hidden;
  margin-right: 7px;
}

.topBox .portrait_div .name {
  color: #333;
  font-size: 14px;
}
.flx {
  display: flex;
  justify-content: center;
  justify-content: space-between;
}
.foot {
  text-align: center;
  height: 106px;
  background: #fff;
  font: 12px;
  color: #999999;
}

.foot a {
  color: #999999;
}

.navigation_ul {
  margin-left: 30px;
  flex: 1;
}

.navigation_li {
  width: 101px;
  height: 112px;
  font-size: 16px;
  cursor: pointer;
  flex-direction: column;
}
.dfdf {
  width: 101px;
  height: 112px;
  font-size: 16px;
  cursor: pointer;
  flex-direction: column;
}
.navigation_ul .navigation_li:hover {
  /* box-shadow: 3px 3px 5px #999; */
  box-shadow: 0px 4px 0px #db414e inset;
}

.navigation_ul .navigation_li .tab_icon {
  width: 30px;
  height: 30px;
  object-fit: none;
  /* object-fit: cover; */
}
.tab_icon2 {
  width: 30px;
  height: 30px;
  object-fit: cover;
}
.navigation_ul .navigation_li p {
  font-size: 16px;
  margin-top: 10px;
}
.navigation_ul .navigation_li.selected {
  color: #fff;
  background: #db414e;
  /* border-radius: 4px; */
}

.navigation_ul .sousuo_div {
  position: relative;
  border-radius: 20px;
  background: #e5e5e5;
  width: 248px;
  max-width: 60%;
  height: 40px;
  padding: 0 4px 0 10px;
  margin-left: 40px;
}

.navigation_ul .sousuo_div > i {
  position: absolute;
  right: 10px;
  width: 24px;
  height: 24px;
}
.icon_search {
  width: 16px;
  height: 16px;
}

.navigation_ul .sousuo_div > input {
  flex: 1;
  margin-right: 10px;
  font-size: 15px;
  border: 0;
  height: 100%;
  padding-left: 10px;
}

.login_button {
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login_button p {
  display: flex;
  width: 74px;
  font-size: 14px;
  margin-top: 2px;
  justify-content: space-between;
  color: #666;
}
.login_button > i {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  /* margin-right: 18px; */
  background: #eeeeee;
  overflow: hidden;
}
.flx {
}
.flx > i {
  width: 58px;
  border-radius: 50%;
  /* margin-right: 18px; */
  background: #eeeeee;
  overflow: hidden;
}
.flx > i > img {
  width: 58px;
  height: auto;
  object-fit: contain;
}
.flx i.message {
  background: transparent;
  position: relative;
  border-radius: 0;
  overflow: auto;
  width: 20px;
  margin-bottom: 7px;
}
.login_button > i > img {
  width: 58px;
  height: auto;
  object-fit: contain;
}
.login_button > i.message {
  background: transparent;
  position: relative;
  border-radius: 0;
  overflow: auto;
  width: 24px;
}
.login_button > i.message img {
  width: 100%;
}
.unread::after {
  content: "";
  position: absolute;
  right: -4px;
  top: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgb(253, 69, 85);
}
.login_button > span {
  font-size: 16px;
  color: #333;
  white-space: nowrap;
}
.login_button > span.shu {
  margin: 0 10px;
}
.sp_re {
  position: relative;
}
.sp_re:hover .drop_box {
  display: block !important;
}
.drop_box {
  position: absolute;
  display: none !important;
  top: 110px;
  left: 0;
  border-radius: 4px;
  color: #555555;
  width: 196px;
  font-size: 16px;
  height: auto;
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 6px 0px;
  z-index: 999;
  box-shadow: 0px 14px 19px 0px rgb(0 0 0 / 30%);
}
.drop_box .item {
  padding: 10px 28px;
}
.drop_box .item:hover {
  background: #db414e;
  color: #fff;
}
.imgmessage {
  width: 20px;
  height: 26px;
  position: relative;
  padding-right:25px;
}
.imgmessage img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/assembly/HeaderTop.vue